import React from 'react';
import PropTypes from 'prop-types';
import QuoteCreationTypeComponent from './QuoteCreationTypeComponent';
import CreateQuoteMakeAndModelComponent from './CreateQuoteMakeAndModelComponent';
import CreateQuoteWeightClass from './CreateQuoteWeightClass';
import { CreateQuoteStep1, quoteCreationType } from '../otherQuoteEntities';
import { DealerBranchSummary } from '../../dealer-branches/dealerBranch';
import { Machine } from '../../machines/machine';
import { ProductConfiguration } from '../../products/productConfiguration';
import { makeConcealable } from '@ami/react/core';
import { Spinner } from '@ami/react/core';
//import './CreateQuoteStep1SelectByComponent.scss';
import CreateQuoteIndustries from './CreateQuoteIndustries';

class CreateQuoteStep1SelectByComponent extends React.PureComponent {
  static propTypes = {
    data: PropTypes.instanceOf(CreateQuoteStep1).isRequired,
    onUpdate: PropTypes.func.isRequired,
    productConfiguration: PropTypes.instanceOf(ProductConfiguration).isRequired,
    machines: PropTypes.arrayOf(PropTypes.instanceOf(Machine)).isRequired,
    selectedDealerBranch: PropTypes.instanceOf(DealerBranchSummary),
    onSkipMakeAndModel: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    isAmiPriceLookupMode: PropTypes.bool,
  };

  state = {
    industries: [],
  };
  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      const preferredMakeIds = this.getPreferredMakeIds();
      if (preferredMakeIds.length === 1) {
        this.props.onUpdate({ manufacturer: preferredMakeIds[0] });
      }
    }
  }

  getWeightCategoriesFor = (carrierId) => {
    return !carrierId
      ? []
      : this.props.productConfiguration.carriers.find((x) => x.id === carrierId)
          .weightCategories;
  };

  getPreferredMakeIds = () => {
    if (!this.props.selectedDealerBranch) {
      return [];
    }

    return this.props.selectedDealerBranch.preferredMakes || [];
  };

  getTerritoryManager = () => {
    if (!this.props.selectedDealerBranch) {
      return null;
    }

    return this.props.selectedDealerBranch.territoryManager;
  };

  render() {
    const {
      data,
      onUpdate,
      machines,
      canSelect,
      productConfiguration,
      onSkipMakeAndModel,
      loading,
      isAmiPriceLookupMode
    } = this.props;
    const { industries } = this.state;
    if (loading) {
      return (
        <div className="container text-center mt-5 mb-5">
          <h4 className="mt-5 mb-2">Loading</h4>
          <Spinner show={true} size="fa-3x" />
        </div>
      );
    }
    if (!canSelect) {
      const contact = this.getTerritoryManager();
      const carrier = productConfiguration.carriers.find(
        (x) => x.id === data.carrierId
      );
      return (
        <div className="row my-2">
          <div className="col-md-8 offset-md-2 text-center">
            <div className="alert alert-warning disabled-carrier" role="alert">
              {contact && (
                <div>
                  Please contact {contact.fullName} for pricing on{' '}
                  {carrier.name} attachments
                  {contact.phoneNumber && (
                    <div className="d-flex justify-content-center">
                      <strong>Cell:&nbsp;&nbsp;</strong>{' '}
                      <a href={'tel:' + contact.phoneNumber}>
                        {contact.phoneNumber}
                      </a>
                    </div>
                  )}
                  <div className="d-flex justify-content-center">
                    <strong>Email:&nbsp;&nbsp;</strong>{' '}
                    <a href={'mailto:' + contact.email}>{contact.email}</a>
                  </div>
                </div>
              )}
              {!contact && (
                <span>
                  <i className="fa fa-exclamation-circle text-danger me-3"></i>
                  Please contact AMI for pricing on {carrier.name} attachments
                </span>
              )}
            </div>
          </div>
        </div>
      );
    }
    const weightCategories = this.getWeightCategoriesFor(data.carrierId);
    return (
      <React.Fragment>
        <React.Fragment>
          <div className="row my-2">
            <QuoteCreationTypeComponent
              onChange={(type) =>
                this.props.onUpdate({
                  type,
                  manufacturer: null,
                  model: '',
                  weightCategoryId: null,
                })
              }
              selectedType={data.type}
              showOptions={weightCategories.length > 1}
            />
          </div>
          {weightCategories.length === 1 && data.type === 1 && (
            <div className="row mb-3">
              <div className="col-md-8 offset-md-2 text-center">
                <button
                  type="button"
                  className="btn btn-link p-0 ps-2"
                  onClick={() => onSkipMakeAndModel(weightCategories[0])}
                >
                  Skip selecting a make &amp; model
                </button>
              </div>
            </div>
          )}
          <CreateQuoteMakeAndModelComponent
            data={data}
            preferredMakeIds={this.getPreferredMakeIds()}
            onUpdate={onUpdate}
            manufacturers={productConfiguration.manufacturers}
            machines={machines}
            weightCategories={productConfiguration.getFlatWeightCategories()}
            show={data.type === quoteCreationType.byMakeAndModel}
            scrollOnShow={true}
          />
        </React.Fragment>
        <CreateQuoteWeightClass
          weightCategoryId={data.weightCategoryId}
          onUpdate={onUpdate}
          weightCategories={weightCategories}
          show={data.type === quoteCreationType.byWeightClass}
          scrollOnShow={true}
        />
        <br />
        {!isAmiPriceLookupMode && <CreateQuoteIndustries
          industryId={data.industryId}
          carrierId={data.carrierId}
          weightCategoryId={data.weightCategoryId}
          onUpdate={onUpdate}
          industries={industries}
          show={!!data.weightCategoryId}
          scrollOnShow={true}
          title={'Select an industry'}
        />}
      </React.Fragment>
    );
  }
}

export default makeConcealable(CreateQuoteStep1SelectByComponent);
